import styled from 'styled-components';

export const ErrorCoverBox = styled.div`
  padding: 2rem;
  margin: 1rem;
  border-radius: 6px;
  background: #f9f9f9;
`;

export const ErrorCoverPre = styled.pre`
  word-break: break-all;
  white-space: pre-wrap;
  margin: 0;
`;
